import { operatorApiFetch } from './apiService';

export const locationSnapshotService = {
  summary: async (params) => {
    const response = await operatorApiFetch('location_snapshots/summary', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },
  export: async (params) => {
    const response = await operatorApiFetch('location_snapshots/export', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  }
};

export default locationSnapshotService;
